export default "__VITE_ASSET__DtR0HZQ$__"